/**
 * An error type that aggregates other errors
 * @param message - the error message
 */
export default class CompositeError extends Error {
  errors: Array<Error>;

  constructor(message?: string) {
    super(message);
    this.name = 'CompositeError';
    this.errors = [];
  }

  /**
   * Add and error to the list
   * @param err - the new error to add
   */
  addError(err: Error | undefined): void {
    if (err) {
      this.errors.push(err);
    }
  }

  lastError(): Error | undefined {
    if (this.errors.length == 0) {
      return;
    }
    return this.errors[this.errors.length - 1];
  }
}
